module.exports = {
  "spacing": 4,
  "palette": {
    "primary": {
      "background": "rgba(0, 118, 223, 0.1)",
      "backgroundText": "#001666",
      "lighter": "#9DDEFF",
      "lighterText": "#001666",
      "light": "#57B6FF",
      "lightText": "#001666",
      "main": "#0076DF",
      "mainText": "#fff",
      "dark": "#0050C7",
      "darkText": "#fff",
      "text": "#001666",
      "_isBasePalette": true
    },
    "orange": {
      "background": "rgba(255, 133, 15, 0.1)",
      "backgroundText": "#551E00",
      "lighter": "#FCD583",
      "lighterText": "#551600",
      "light": "#FFB947",
      "lightText": "#551E00",
      "main": "#FF850F",
      "mainText": "#551E00",
      "dark": "#D93F02",
      "darkText": "#fff",
      "text": "#571600",
      "_isBasePalette": true
    },
    "red": {
      "background": "rgba(212, 36, 36, 0.1)",
      "backgroundText": "#570000",
      "lighter": "#FA8B75",
      "lighterText": "#570000",
      "light": "#F45B4D",
      "lightText": "#570000",
      "main": "#D42424",
      "mainText": "#fff",
      "dark": "#920125",
      "darkText": "#fff",
      "text": "#570000",
      "_isBasePalette": true
    },
    "green": {
      "background": "rgba(0, 135, 74, 0.1)",
      "backgroundText": "#002902",
      "lighter": "#98DC8E",
      "lighterText": "#002902",
      "light": "#53C65E",
      "lightText": "#002902",
      "main": "#00874A",
      "mainText": "#fff",
      "dark": "#004E03",
      "darkText": "#fff",
      "text": "#002902",
      "_isBasePalette": true
    },
    "purple": {
      "background": "rgba(158, 48, 209, 0.1)",
      "backgroundText": "#320266",
      "lighter": "#F9B4FD",
      "lighterText": "#320266",
      "light": "#E680FF",
      "lightText": "#320266",
      "main": "#9E30D1",
      "mainText": "#fff",
      "dark": "#550F9B",
      "darkText": "#fff",
      "text": "#320266",
      "_isBasePalette": true
    },
    "teal": {
      "background": "rgba(0, 204, 191, 0.1)",
      "backgroundText": "#073C37",
      "lighter": "#B7EEEA",
      "lighterText": "#073C37",
      "light": "#85E7E0",
      "lightText": "#073C37",
      "main": "#00CABD",
      "mainText": "#073C37",
      "dark": "#007165",
      "darkText": "#fff",
      "text": "#073C37",
      "_isBasePalette": true
    },
    "black": {
      "lightest": "rgba(0,0,0,0.05)",
      "lightestText": "#000",
      "lighter": "rgba(0,0,0,0.1)",
      "lighterText": "#000",
      "light": "rgba(0,0,0,0.4)",
      "lightText": "#fff",
      "main": "rgba(0,0,0,0.6)",
      "mainText": "#fff",
      "dark": "rgba(0,0,0,0.9)",
      "darkText": "#fff",
      "solid": "rgb(0,0,0)",
      "solidText": "#fff",
      "_isBasePalette": true
    },
    "lightGray": {
      "main": "#F6F6F6",
      "mainText": "#000",
      "_isBasePalette": true
    },
    "darkGray": {
      "light": "rgba(49, 57, 68, 0.7)",
      "lightText": "#fff",
      "main": "#313944",
      "mainText": "#fff",
      "_isBasePalette": true
    },
    "white": {
      "main": "#FFFFFF",
      "mainText": "#000000",
      "_isBasePalette": true
    },
    "success": {
      "background": "rgba(0, 135, 74, 0.1)",
      "backgroundText": "#002902",
      "lighter": "#98DC8E",
      "lighterText": "#002902",
      "light": "#53C65E",
      "lightText": "#002902",
      "main": "#00874A",
      "mainText": "#fff",
      "dark": "#004E03",
      "darkText": "#fff",
      "text": "#002902",
      "_isBasePalette": true
    },
    "error": {
      "background": "rgba(212, 36, 36, 0.1)",
      "backgroundText": "#570000",
      "lighter": "#FA8B75",
      "lighterText": "#570000",
      "light": "#F45B4D",
      "lightText": "#570000",
      "main": "#D42424",
      "mainText": "#fff",
      "dark": "#920125",
      "darkText": "#fff",
      "text": "#570000",
      "_isBasePalette": true
    },
    "warning": {
      "background": "rgba(255, 133, 15, 0.1)",
      "backgroundText": "#551E00",
      "lighter": "#FCD583",
      "lighterText": "#551600",
      "light": "#FFB947",
      "lightText": "#551E00",
      "main": "#FF850F",
      "mainText": "#551E00",
      "dark": "#D93F02",
      "darkText": "#fff",
      "text": "#571600",
      "_isBasePalette": true
    },
    "secondary": {
      "background": "rgba(158, 48, 209, 0.1)",
      "backgroundText": "#320266",
      "lighter": "#F9B4FD",
      "lighterText": "#320266",
      "light": "#E680FF",
      "lightText": "#320266",
      "main": "#9E30D1",
      "mainText": "#fff",
      "dark": "#550F9B",
      "darkText": "#fff",
      "text": "#320266",
      "_isBasePalette": true
    },
    "disabled": {
      "main": "rgba(0,0,0,0.4)"
    },
    "border": {
      "main": "rgba(0,0,0,0.1)"
    },
    "background": {
      "default": "#F6F6F6"
    },
    "text": {
      "primary": "rgba(0,0,0,0.9)",
      "secondary": "rgba(0,0,0,0.6)",
      "disabled": "rgba(0,0,0,0.4)",
      "hint": "rgba(0,0,0,0.4)",
      "main": "rgba(0,0,0,0.9)"
    }
  },
  "props": {
    "MuiButtonBase": {
      "disableRipple": true
    },
    "MuiCheckbox": {
      "disableRipple": false
    },
    "MuiFormControl": {
      "fullWidth": true
    },
    "MuiTextField": {},
    "MuiRadio": {
      "color": "primary"
    },
    "MuiSwitch": {
      "color": "primary"
    },
    "MuiModal": {
      "open": false
    },
    "MuiCardHeader": {
      "titleTypographyProps": {
        "variant": "h3"
      }
    }
  },
  "interactivity": {
    "transition": "0.1s ease-out"
  },
  "typography": {
    "fontSize": 14,
    "fontFamily": "Nunito Sans",
    "h1": {
      "fontSize": 36,
      "fontWeight": 700,
      "lineHeight": "40px"
    },
    "h2": {
      "fontSize": 28,
      "fontWeight": 700,
      "lineHeight": "32px"
    },
    "h3": {
      "fontSize": 20,
      "fontWeight": 700,
      "lineHeight": "24px"
    },
    "h4": {
      "fontSize": 16,
      "fontWeight": 700,
      "lineHeight": "20px"
    },
    "h5": {
      "fontSize": 14,
      "fontWeight": 700,
      "lineHeight": "20px"
    },
    "body1": {
      "fontSize": 16,
      "fontWeight": 400,
      "lineHeight": "24px"
    },
    "body2": {
      "fontSize": 14,
      "fontWeight": 400,
      "lineHeight": "20px"
    },
    "subtitle1": {
      "fontSize": 16,
      "fontWeight": 400,
      "lineHeight": "24px",
      "color": "rgba(0,0,0,0.6)"
    },
    "subtitle2": {
      "fontSize": 14,
      "fontWeight": 400,
      "lineHeight": "20px",
      "color": "rgba(0,0,0,0.6)"
    }
  },
  "overrides": {
    "MuiPopover": {
      "paper": {
        "boxShadow": "0 0 0 1px rgba(0,0,0,0.05), 0 4px 8px rgba(0,0,0,0.1)",
        "marginTop": "8px"
      }
    },
    "MuiTabs": {
      "indicator": {
        "bottom": "-1px",
        "height": "3px"
      },
      "root": {
        "overflow": "initial",
        "border": "initial",
        "font-size": "14px",
        "font-weight": "600",
        "boxSizing": "border-box",
        "minHeight": "38px",
        "lineHeight": "38px",
        "color": "rgba(0,0,0,0.9)",
        "& path": {
          "fill": "black",
          "opacity": "0.9"
        },
        "& div": {
          "overflow": "initial"
        }
      }
    },
    "MuiTypography": {
      "gutterBottom": {
        "marginBottom": 12
      }
    },
    "MuiBackdrop": {
      "root": {
        "background": "rgba(49, 57, 68, .7)"
      }
    },
    "MuiSelect": {
      "selectMenu": {
        "minHeight": "32px",
        "lineHeight": "32px",
        "padding": "4px 24px 4px 8px"
      }
    },
    "MuiAppBar": {
      "colorPrimary": {
        "backgroundColor": "#FFFFFF"
      },
      "root": {
        "backgroundColor": "#FFFFFF"
      }
    },
    "MuiTab": {
      "root": {
        "padding": "0 24px",
        "textTransform": "none",
        "fontSize": "14px !important",
        "fontWeight": "bold",
        "minWidth": "auto !important"
      },
      "textColorInherit": {
        "color": "rgba(0,0,0,0.9)"
      }
    },
    "MuiListItem": {
      "root": {
        "minHeight": "40px"
      },
      "dense": {
        "& .MuiListItemText-multiline": {
          "& .MuiListItemText-primary": {
            "paddingBottom": "0px"
          }
        }
      }
    },
    "MuiListItemText": {
      "root": {
        "textAlign": "left",
        "padding": 0
      },
      "multiline": {
        "& .MuiListItemText-primary": {
          "fontWeight": "bold",
          "paddingBottom": "4px"
        }
      }
    },
    "MuiListItemIcon": {
      "root": {
        "color": "rgba(0,0,0,0.6)",
        "minWidth": "24px"
      }
    },
    "MuiListItemAvatar": {
      "root": {
        "minWidth": "40px"
      }
    },
    "MuiPrivateTabIndicator": {
      "root": {
        "height": 3
      },
      "colorSecondary": {
        "backgroundColor": "#0076DF"
      }
    },
    "MuiTabIndicator": {
      "colorSecondary": {
        "backgroundColor": "#0076DF"
      }
    },
    "MuiLinearProgress": {
      "colorPrimary": {},
      "barColorPrimary": {
        "backgroundColor": "#0076DF"
      }
    },
    "MuiSlider": {
      "track": {
        "backgroundColor": "#0076DF"
      },
      "trackBefore": {
        "backgroundColor": "#0076DF"
      }
    },
    "MuiButton": {
      "root": {
        "fontWeight": "700",
        "shadows": "none",
        "textTransform": "none",
        "boxShadow": "none",
        "minWidth": "auto",
        "height": "40px",
        "lineHeight": "inherit",
        "fontSize": "14px",
        "&$disabled": {
          "border": "none",
          "color": "#FFFFFF",
          "backgroundColor": "rgba(0,0,0,0.4)"
        }
      },
      "sizeLarge": {
        "padding": "0 20px",
        "fontSize": "16px",
        "minHeight": 48
      },
      "contained": {
        "textTransform": "none",
        "boxShadow": "none",
        "&$focusVisible": {
          "boxShadow": "none"
        },
        "&:active": {
          "boxShadow": "none"
        },
        "&:hover": {
          "boxShadow": "none"
        },
        "&$disabled": {
          "boxShadow": "none"
        }
      },
      "containedPrimary": {
        "color": "#FFFFFF",
        "fontSize": "14px",
        "fontWeight": "700",
        "border": "1px solid #0076DF",
        "&:hover": {
          "backgroundColor": "#0050C7",
          "border": "1px solid #0050C7",
          "boxShadow": ["none"]
        },
        "&$disabled": {
          "border": "none",
          "color": "#FFFFFF",
          "backgroundColor": "rgba(0,0,0,0.4)"
        }
      },
      "containedSecondary": {
        "border": "1px solid #FFFFFF",
        "fontSize": "14px",
        "fontWeight": "700",
        "backgroundColor": "#FFFFFF",
        "color": "#0076DF",
        "&:hover": {
          "backgroundColor": "#f5f6f7 !important",
          "border": "1px solid #f5f6f7 !important",
          "boxShadow": ["none"]
        },
        "&$disabled": {
          "border": "none",
          "color": "#FFFFFF",
          "backgroundColor": "rgba(0,0,0,0.4)"
        }
      },
      "outlined": {
        "&$disabled": {
          "border": "1px solid rgba(0,0,0,0.4)",
          "color": "rgba(0,0,0,0.4)",
          "background": "none !important"
        }
      },
      "outlinedPrimary": {
        "&$disabled": {
          "border": "1px solid rgba(0,0,0,0.4)",
          "color": "rgba(0,0,0,0.4)",
          "background": "none !important"
        }
      },
      "outlinedSecondary": {
        "fontWeight": "700",
        "fontSize": "14px",
        "border": "1px solid rgba(0,0,0,0.1)",
        "color": "#0076DF",
        "&:hover": {
          "border": "1px solid rgba(0,0,0,0.1)",
          "backgroundColor": "rgba(0, 0, 0, 0.08)",
          "color": "#0076DF"
        },
        "&$disabled": {
          "border": "1px solid rgba(0,0,0,0.4)",
          "color": "rgba(0,0,0,0.4)",
          "background": "none !important"
        }
      }
    },
    "MuiIcon": {
      "root": {
        "fontSizeSmall": {
          "fontSize": 5
        },
        "fontSizeLarge": {
          "fontSize": 50
        }
      }
    },
    "MuiIconButton": {
      "root": {
        "borderRadius": "4px",
        "padding": "8px"
      }
    },
    "MuiFormControl": {
      "root": {
        "& .MuiOutlinedInput-root legend span": {
          "padding": 0
        },
        "& .MuiFormLabel-root + .MuiOutlinedInput-root legend > span": {
          "padding": "0 5px"
        }
      }
    },
    "MuiOutlinedInput": {
      "root": {
        "&$focused $notchedOutline": {
          "borderColor": "#57B6FF"
        },
        "&$disabled": {
          "color": "rgba(0,0,0,0.4)",
          "borderRadius": "3px"
        }
      },
      "input": {
        "padding": "0px 14px",
        "lineHeight": "16px",
        "fontSize": "16px",
        "height": "40px"
      },
      "inputMarginDense": {
        "paddingTop": 0,
        "paddingBottom": 0
      }
    },
    "MuiInputLabel": {
      "outlined": {
        "transform": "translate(14px, 15px) scale(1)"
      },
      "formControl": {
        "top": "-3px"
      }
    },
    "MuiFilledInput": {
      "root": {
        "backgroundColor": "#F6F6F6",
        "borderRadius": "0 !important"
      }
    },
    "MuiExpansionPanel": {
      "root": {
        "&$expanded": {
          "margin": 0,
          "minHeight": "48px",
          "&:before": {
            "opacity": 1
          }
        }
      }
    },
    "MuiExpansionPanelSummary": {
      "root": {
        "minHeight": "48px !important"
      },
      "content": {
        "margin": "12px 0 !important"
      }
    },
    "MuiExpansionPanelDetails": {
      "root": {
        "padding": "24px",
        "backgroundColor": "rgba(0,0,0,0.05)"
      }
    },
    "MuiModal": {
      "root": {
        "zIndex": "1800",
        "&[role=\"presentation\"]": {
          "maxHeight": "600px !important"
        }
      }
    },
    "MuiSwitch": {
      "root": {
        "width": 60,
        "height": 44,
        "&$checked": {
          "backgroundColor": "#0082ED !important"
        }
      },
      "colorPrimary": {
        "&$disabled": {
          "& + $track": {
            "opacity": 0.4
          },
          "&$checked": {
            "& + $track": {
              "backgroundColor": "#0076DF !important"
            }
          }
        }
      },
      "switchBase": {
        "padding": 6,
        "margin": 8,
        "borderRadius": "50%",
        "transition": "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 300ms cubic-bezier(0.08, 0.57, 0.52, 0.89) 0ms",
        "&$checked": {
          "left": 0,
          "transform": "translateX(57%)",
          "& + $track": {
            "opacity": 1
          }
        },
        "&$disabled": {
          "& + $track": {
            "backgroundColor": "rgba(0,0,0,0.1) !important"
          }
        }
      },
      "track": {
        "borderRadius": 10,
        "opacity": 1,
        "backgroundColor": "rgba(0,0,0,0.1)"
      },
      "thumb": {
        "width": 16,
        "height": 16,
        "boxShadow": "0 3px 6px rgba(0,0,0,0.1), 0 2px 2px rgba(0,0,0,0.4)",
        "backgroundColor": "#FFFFFF",
        "&$disabled": {
          "backgroundColor": "#F6F6F6"
        }
      }
    },
    "MuiCheckbox": {
      "root": {
        "padding": "4px",
        "margin": "0 8px",
        "&$checked": {
          "color": "#0076DF"
        }
      },
      "colorSecondary": {
        "color": "#0076DF"
      }
    },
    "MuiTableRow": {
      "root": {
        "height": "48px"
      }
    },
    "MuiMenuItem": {
      "root": {
        "fontSize": 16,
        "color": "rgba(0,0,0,0.9)"
      }
    },
    "MuiCardHeader": {
      "action": {
        "marginTop": 0,
        "marginBottom": 0
      }
    },
    "MuiButtonGroup": {
      "root": {
        "boxShadow": "none"
      },
      "contained": {
        "boxShadow": "none"
      }
    },
    "MuiChip": {
      "root": {
        "& label": {
          "padding": "0px 14px !important"
        },
        "& span": {
          "padding": "0px 14px !important"
        }
      }
    },
    "MuiAutocomplete": {
      "root": {
        "& [class*=\"MuiInputLabel-formControl\"]": {
          "top": 0
        }
      },
      "inputRoot": {
        "&[class*=\"MuiOutlinedInput-root\"]": {
          "padding": 0,
          "paddingLeft": 9,
          "& [class*=\"MuiAutocomplete-input\"]": {
            "padding": 0
          },
          "& [class*=\"MuiOutlinedInput-input\"]": {
            "height": "inherit",
            "padding": "18.5px 14px",
            "lineHeight": "inherit"
          },
          "& [class*=\"MuiOutlinedInput-inputMarginDense\"]": {
            "paddingTop": 10.5,
            "paddingBottom": 10.5
          }
        }
      }
    }
  }
};